import { EMPTY_OBJECT, NOTIFICATION_TYPE } from '../../../../constants/common'
import {
  getRequestEditStatusModalInitialValues,
  getRequestEditStatusModalSubmitPayload,
} from '../../RequestEditStatusModal'

import {
  ATTACH_SERVICE_REQUESTS_STATUS_ACTION_CONFIG,
  ATTACH_SERVICE_REQUESTS_STATUS_MODAL_FIELD_NAME_CHANGE_STATUS,
} from './AttachServiceRequestsStatusModal.constants'

export function getAttachServiceRequestsStatusModalInitialValues() {
  return {
    ...getRequestEditStatusModalInitialValues(),
    [ATTACH_SERVICE_REQUESTS_STATUS_MODAL_FIELD_NAME_CHANGE_STATUS]: false,
  }
}

export function getAttachServiceRequestsStatusModalInitialNotifications(
  action,
  t
) {
  return [
    {
      text: t(
        ATTACH_SERVICE_REQUESTS_STATUS_ACTION_CONFIG[action].notification
      ),
      type: NOTIFICATION_TYPE.info,
    },
  ]
}

export function getAttachServiceRequestsStatusModalPayload(values) {
  return values[ATTACH_SERVICE_REQUESTS_STATUS_MODAL_FIELD_NAME_CHANGE_STATUS]
    ? getRequestEditStatusModalSubmitPayload(values)
    : EMPTY_OBJECT
}
